import React, { useEffect, useState } from 'react';
import { compose } from 'ramda';
import Dashboard from 'components/Layout/Dashboard/Dashboard';
import withMeta from 'hoc/withMeta';
import ManagePolicies from 'components/ExistingPolicies/ManagePolicies';
import Store from 'store/store';
import api from 'api';
import Router from 'components/Router/Router';
import { ExistingPolicyType } from 'store/modules/ExistingPolicies/types';
import { Loader } from 'components/Base';
import { MetaType } from 'store/modules/Meta/types';
import withCaseInfo from 'hoc/withCaseInfo';
import { errHelper } from 'utils';
import { mapCipOptions } from 'components/InvestmentAnalyser/utils';
import { useDispatch } from 'react-redux';
import { getExistingPolicies } from 'components/Cases/utils';

const { connect, actions, selectors } = Store;
const { useParams } = Router;

interface ExistingPoliciesProps {
  existingPolicies: Array<ExistingPolicyType>;
  chargeTypes: Array<MetaType>;
  addNewPolicy: any;
  removeExistingPolicy: any;
  markAsSaved: any;
  updateModelPortfolios: Function;
  updateCipOptions: Function;
}

const ManagePoliciesPage = ({
  existingPolicies,
  chargeTypes,
  addNewPolicy,
  removeExistingPolicy,
  markAsSaved,
  updateModelPortfolios,
  updateCipOptions
}: ExistingPoliciesProps) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { portfolio } = useParams() as any;

  useEffect(() => {
    setIsLoading(true);
    dispatch(getExistingPolicies(portfolio) as any)
      .then(() => {
        api.getModelPortfolios().then(response => {
          updateModelPortfolios(response);
          setIsLoading(false);
        });
      })
      .catch((err: any) => {
        setIsLoading(false);
        errHelper(err);
      });

    api.getCipRelations({ cip_thresholds: null }).then(({ data }) => {
      updateCipOptions(mapCipOptions(data));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dashboard>
      <Loader isLoading={isLoading}>
        <ManagePolicies
          existingPolicies={existingPolicies}
          chargeTypes={chargeTypes}
          addNewPolicy={addNewPolicy}
          removeExistingPolicy={removeExistingPolicy}
          markAsSaved={markAsSaved}
        />
      </Loader>
    </Dashboard>
  );
};

export default compose(
  connect(
    state => ({
      existingPolicies: selectors.caseSelectors.existingPolicies(state),
      chargeTypes: selectors.metaSelectors.chargeTypes(state)
    }),
    {
      addNewPolicy: actions.caseActions.addNewExistingPolicy,
      removeExistingPolicy: actions.caseActions.removeExistingPolicy,
      markAsSaved: actions.caseActions.markAsSaved,
      updateModelPortfolios: actions.metaActions.updateModelPortfolios,
      updateCipOptions: actions.investmentAnalyserActions.updateCipOptions
    }
  ),
  withMeta,
  withCaseInfo
)(ManagePoliciesPage);
